export default "__VITE_PUBLIC_ASSET__3300283c__"